import { create } from 'apisauce';

import { api, HEADERS, apiSetup } from '~config/api';
import { API_URL } from '~config/environment';
import PollingService from '~services/PollingService';
import LocalStorageService from '~services/LocalStorageService';
import { UserService } from '~services/Users/service';

export const OrderService = {
  checkOrder: ({ token }) => {
    const { headers } = api;
    const temporalApi = create({
      baseURL: API_URL,
      headers: {
        [HEADERS.JOB_AUTHORIZATION]: token,
        [HEADERS.TENANT]: headers[HEADERS.TENANT]
      }
    });
    apiSetup(temporalApi);
    return temporalApi.get('v1/orders_job');
  },
  getOrders: ({ storeId, ordersFilter, page = 1 }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    const params = new URLSearchParams();
    if (ordersFilter) params.append('status', ordersFilter);
    params.append('page', page);
    return api.get(`v1/kds/store/${storeId}/orders?${params.toString()}`);
  },
  getOrderById: ({ storeId, id, cancelToken }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    return api.get(`v1/kds/store/${storeId}/orders/${id}`, null, {
      cancelToken
    });
  },
  updateOrderStatus: ({ status, orderId, storeSelected }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeSelected);
    return PollingService.poll(
      api.patch(`v1/kds/store/${storeSelected}/orders/${orderId}`, {
        order: {
          status
        }
      }),
      OrderService.checkOrder
    );
  },
  updateOrderDeliveryType: ({ orderId, storeId, estimationId }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    return PollingService.poll(
      api.post(`v1/kds/store/${storeId}/orders/${orderId}/deliveries`, {
        delivery: { deliveryEstimationId: estimationId }
      }),
      OrderService.checkOrder
    );
  },
  getQuantityOrders: ({ storeId }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    return api.get(`v1/kds/store/${storeId}/orders/status`);
  },
  createOrder: async ({ order, userId, requestedTime, online_payment }) => {
    // Obtener el token del administrador
    const tokenManager = LocalStorageService.getTokenManager && LocalStorageService.getTokenManager();
    const token = tokenManager?.accessToken;
    if (userId) {
      api.setHeader(HEADERS.USER_ID, userId);
    } else {
      const user = {
        name: order.user_name,
        email: order.user_email,
        phone: order.user_phone
      };
      const response = await UserService.createGuestUser({ user });
      const externalId = response.data.externalId;
      api.setHeader(HEADERS.USER_ID, externalId);
    }
    const headers = {
      [HEADERS.PLATFORM]: 'order_taker',
      ...(token ? { Authorization: token } : {})
    };
    return api
      .post('/v1/admin/orders/', { order, requested_time: requestedTime, online_payment }, { headers })
      .then(async (res) => {
        const orderToken = res.data.token;
        if (res && res.data && res.data.token) {
          const verification = await PollingService.poll(
            Promise.resolve({ ok: true, data: { token: orderToken } }),
            ({ token }) => OrderService.checkOrder({ token })
          );
          return { order: res, verification };
        }
        return { order: res };
      })
      .catch((err) => {
        console.error('❌ Error al enviar orden:', err.response?.data || err.message);
        throw err;
      });
  }
};

export default OrderService;
